import React from "react";
import { Section, Container, Eyebrow, RevealHeading, Reveal } from "@/components/primitives";
import { PageHero } from "@/components/PageHero";
import { ServiceGrid } from "@/components/ServiceGrid";
import { FlowDiagram } from "@/components/FlowDiagram";
import { CTASection } from "@/components/CTASection";
import { Seo } from "@/components/Seo";
import { GOVERNMENT } from "@/data/site";
import { PRACTICE_SERVICES } from "@/data/services";

export default function Government() {
  const g = GOVERNMENT;
  return (
    <>
      <Seo
        title="Government | GovX Nigeria"
        description="GovX Nigeria partners with government institutions to strengthen the systems between policy and outcomes — governance transformation, programme delivery, M&E and citizen experience."
      />
      <PageHero {...g.hero} kicker="Public Administration — Nigeria" />

      {/* Policy to People */}
      <Section className="py-24 lg:py-32">
        <Container>
          <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
            <div>
              <Eyebrow>From Policy To People</Eyebrow>
              <RevealHeading
                lines={["A Government Decision", "Is Only The Beginning."]}
                as="h2"
                className="mt-7 font-display text-3xl font-medium leading-[1.05] tracking-tight sm:text-4xl"
              />
              <Reveal delay={0.1}>
                <p className="mt-6 max-w-md text-base leading-relaxed text-govx-charcoal/65">
                  We help institutions move from policy to a measurable citizen outcome — building
                  the systems that connect every stage in between.
                </p>
              </Reveal>
            </div>
            <Reveal delay={0.15}>
              <div className="border border-govx-charcoal/10 bg-white p-8 lg:p-10">
                <FlowDiagram steps={g.flow} dark={false} />
              </div>
            </Reveal>
          </div>
        </Container>
      </Section>

      {/* Services */}
      <Section dark className="py-24 lg:py-32">
        <Container className="relative z-10">
          <Eyebrow dark>Capabilities</Eyebrow>
          <RevealHeading
            lines={["What We Do For Government"]}
            as="h2"
            className="mt-7 font-display text-3xl font-medium tracking-tight sm:text-5xl"
          />
          <div className="mt-14">
            <ServiceGrid slugs={PRACTICE_SERVICES.Government} dark />
          </div>
        </Container>
      </Section>

      <CTASection
        eyebrow="Government"
        title={["Have a programme", "that needs to move?"]}
        copy="Let's map the problem, identify the bottlenecks and build a delivery system around it."
        cta="Start a Government Conversation"
      />
    </>
  );
}
